jQuery(function($) {
    $(".nav li").click(function() {
        $(this).addClass('active').siblings().removeClass('active');
        $(document).on("click", function(event){
            var $trigger = $(".nav li");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $(".nav li").removeClass("active");
            }            
        });
    });
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".header, .nav_mobiles").addClass("header_background_active");
        } else {
            $(".header, .nav_mobiles").removeClass("header_background_active");
        }
    });
    $(".nav_mobiles .button_menu").click(function() {
        $nav =  $('.nav_mobiles .nav');
        $main = $('.wrapper_god');
        if($(this).hasClass('button_active')){
            $(this).removeClass('button_active');
            $($nav).removeClass('nav_active');
            $($main).removeClass('nav_active');
        } else {
            $(this).addClass('button_active')
            $($nav).addClass('nav_active');
            $($main).addClass('nav_active');
        }
    });
    $(window).load(function(){
        $('a[href*="#"]').on('click', function(e) {
            e.preventDefault()
            var extraOffset = 100;
            $('html, body').animate(
              { scrollTop: $($(this).attr('href')).offset().top - extraOffset,}, 800,'linear'
            )
          })
    });
});
